/* eslint-disable camelcase */
;(function module() {
  angular.module('app.ui.form.ctrls').controller('ContactAdminController', [
    '$uibModalInstance',
    'PositionApi',
    'selectedPosition',
    'logger',
    function controller(
      $uibModalInstance,
      PositionApi,
      selectedPosition,
      logger
    ) {
      var vm = this
      vm.submitQuestion = async () => {
        try {
          analytics.track('Question Asked', {
            question: vm.lawyerQuestion,
            lawyer_id: selectedPosition.userId,
            job_id: selectedPosition.id,
            job_title: selectedPosition.title,
            job_max_pqe: selectedPosition.lawPreferences.maxPqe,
            job_min_pqe: selectedPosition.lawPreferences.minPqe,
            job_contract: selectedPosition.contractTypeName,
            job_role: selectedPosition.occupationName,
            job_address: '',
            employer_type:
              selectedPosition.employerTypes.filter(
                ({name}) => name === 'Private Practice'
              ).length > 0
                ? 'Private Practice'
                : 'In-House',
            firm_id: selectedPosition.employerId,
            firm_name: selectedPosition.employer.name,
            page: 'My LexStep Matches',
          })
        } catch (error) {
          console.error('My LexStep Matches', error)
        }

        try {
          const response = await PositionApi.addPositionQuestion(
            selectedPosition.id,
            {userId: selectedPosition.userId, body: vm.lawyerQuestion}
          )
          if (response.status === 201) {
            logger.notify(
              'success',
              'Your question has been submitted successfully! We will get back to you as soon as possible'
            )
          }
        } catch (error) {
          logger.notify(
            'error',
            'There was an error in submitting your question. Please try again'
          )
        }

        $uibModalInstance.close(vm.lawyerQuestion)
      }

      vm.cancel = () => {
        $uibModalInstance.dismiss('cancel')
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/contact-admin/contact-admin.ctrl.js